/*
 * Copyright © 2021 Firecrest Clinical, Ltd.
 * All rights reserved.
*/

import DateTimeFormatOptions = Intl.DateTimeFormatOptions;

export interface FcDatepickerData {
    filter?: any;
    startDate: Date | undefined | null,
    endDate: Date | undefined | null,
}

export interface FcDatePickerFormat {
    display?: string,
    options?: DateTimeFormatOptions
}